import { render, staticRenderFns } from "./NsBadge.vue?vue&type=template&id=2780a7fe&"
import script from "./NsBadge.vue?vue&type=script&lang=js&"
export * from "./NsBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports